import React from "react";
import BudgetCard from "./BudgetCard";
import { useBudgets } from "../contexts/BudgetContext";
import { filterThisWeek } from "../utils";

export default function TotalBudgetCard(props) {
  const { expenses, budgets } = useBudgets();
  const filteredExpenses = filterThisWeek(expenses);
  const amount = filteredExpenses.reduce(
    (total, filteredExpense) => total + filteredExpense.amount,
    0
  );
  const alignedTotal = filteredExpenses.reduce(
    (total, filteredExpense) => total + filteredExpense.aligned,
    0
  );
  const alignedPercent = alignedTotal / filteredExpenses.length;
  const max = budgets.reduce((total, budget) => total + budget.max, 0);
  if (max === 0) return null;
  return (
    <BudgetCard
      amount={amount}
      name="Total"
      gray
      max={max}
      aligned={alignedPercent}
      hideButtons
    ></BudgetCard>
  );
}
